import { useContext } from "react";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO Components
import DashboardLayout from "parts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "parts/Navbars/DashboardNavbar";
import Footer from "parts/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import TaskList from "../../components/tasks/TaskList";
import RestartRoutePreview from "../../components/tasks/RestartRoutePreview";

import { LanguageContext } from "context";

function TaskManager() {
  const { t } = useContext(LanguageContext) as any;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDTypography variant="h4" mb={2}>
          {t("TaskList")}
        </MDTypography>
        <MDBox mb={3}>
          <RestartRoutePreview />
        </MDBox>
        <Card sx={{ p: 2 }}>
          <TaskList />
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default TaskManager;
